import React, { PropTypes } from 'react';
import classnames from 'classnames';

const PromoBanner = ({ image, title, content_html, className = "blue" }) => (
  <section className={classnames('block block-promo-banner', className)}>
    <div className="row">
      { image &&
      <div className="small-4 medium-3 columns"><img src={image.url} alt={image.alt}/></div>}
      <div className="columns">
        <div className="promo-content">
          { !!title && <h2 className="as-h3-important" dangerouslySetInnerHTML={{ __html: title }} /> }
          { !!content_html && <p dangerouslySetInnerHTML={{ __html: content_html }} /> }
        </div>
      </div>
    </div>
  </section>
);

PromoBanner.propTypes = {
  image: PropTypes.object,
  content_html: PropTypes.string,
  className: PropTypes.string,
};

export default PromoBanner;
